<template>
    <router-view></router-view>
</template>

<script>

import LandingContentBaseComponent from './LandingContentBaseComponent.vue';
export default {
    name: 'LandingContent',
    extends: LandingContentBaseComponent
};
</script>